import { Link } from '@tanstack/react-router'
import { Compass } from 'lucide-react'
import { Button } from '~/components/ui/button'
import { Card, EmptyState } from '~/components/ui/primitives'
import { useT } from '~/lib/i18n'

export function NotFoundPage() {
  const t = useT()
  return (
    <Card className="overflow-hidden">
      <div className="hazard h-1.5" aria-hidden />
      <EmptyState
        icon={<Compass className="size-6" />}
        title={t('not_found.that_page_doesnt_exist')}
        description={t('not_found.the_link_may_be_out_of')}
        action={
          <Button asChild size="sm">
            <Link to="/">{t('not_found.go_home')}</Link>
          </Button>
        }
      />
    </Card>
  )
}
